import React, { useEffect } from 'react';
import { LukosPayPremium } from '../../components/custom/LukosPremiumSolutions/LukosPremiumSolutions';
import { motion } from 'framer-motion';

const LukosDashboardPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <LukosPayPremium />

        <section className="py-20 bg-slate-900 text-center text-white">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-black mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
              Tome decisões com dados em tempo real.
            </h2>
            <button className="bg-[#690093] text-white px-10 py-4 rounded-full font-bold text-lg shadow-xl hover:bg-[#59007d] transition-all">
              Solicitar apresentação estratégica
            </button>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default LukosDashboardPage;
